import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";

@Component({
	selector: "app-locked-staking-final-reminder",
	templateUrl: "./locked-staking-final-reminder.component.html",
	styleUrls: ["./locked-staking-final-reminder.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LockedStakingFinalReminderComponent {
	@Output() onButtonClick = new EventEmitter<void>();
}
